import { managerConfig } from "./roles/managerConfig";
import { facilitiesConfig } from "./roles/facilitiesConfig";
import { maintenanceConfig } from "./roles/maintenanceConfig";
import { housekeepingConfig } from "./roles/housekeepingConfig";
import { frontDeskConfig } from "./roles/frontDeskConfig";
import { superuserConfig } from "./roles/superuserConfig";

export const roleConfig = {
  manager: managerConfig,
  facilities: facilitiesConfig,
  maintenance: maintenanceConfig,
  housekeeping: housekeepingConfig,
  frontDesk: frontDeskConfig,
  superuser: superuserConfig,
};

// Helper to get routes for a specific role
export const getRoutesForRole = (userType) => {
  return roleConfig[userType] || [];
};

// Helper to get only nav items for a specific role
export const getNavItemsForRole = (userType) => {
  const routes = getRoutesForRole(userType);
  return routes.filter((route) => route.showInNav);
};

// Helper to check if a route exists for a role
export const roleHasRoute = (userType, path) => {
  const routes = getRoutesForRole(userType);
  return routes.some((route) => route.path === path);
};

// Helper to get the default route for a role
export const getDefaultRouteForRole = (userType) => {
  const routes = getRoutesForRole(userType);
  const defaultRoute = routes.find((route) => route.default);
  return defaultRoute?.path || "/";
};
